module.exports = __webpack_public_path__ + "img/5_86.3137fd30.png";